export default function AuthBrandPanel() {
  return (
    <section className="relative hidden overflow-hidden bg-[#EDF1DF] px-12 md:flex md:w-1/2 md:items-center md:justify-center">
      <div className="absolute -left-24 -top-24 h-72 w-72 rounded-full bg-[#DCE8C8] opacity-80" />
      <div className="absolute -bottom-32 -right-20 h-96 w-96 rounded-full bg-[#F5C9A8] opacity-40" />
      <div className="absolute right-[12%] top-[16%] h-24 w-24 rounded-full border border-[#BFD2A4] opacity-70" />

      <div className="relative z-10 w-full max-w-xl">
        <div className="mb-10 flex items-center gap-3">
          <span className="grid h-11 w-11 -rotate-3 place-items-center rounded-[14px_14px_14px_5px] bg-[#274D3B] text-xl font-bold text-white">
            M
          </span>
          <span className="text-sm font-extrabold uppercase tracking-[0.2em] text-[#274D3B]">
            Marstrix Story Generator
          </span>
        </div>

        <h1 className="max-w-lg text-5xl font-black leading-[1.08] tracking-tight text-gray-950">
          Their life.<br />
          Their story.<br />
          Their way to learn.
        </h1>

        <div className="my-8 h-1 w-16 rounded-full bg-[#6F9654]" />

        <p className="max-w-xl text-xl font-medium leading-relaxed text-gray-800">
          Turn real-life situations, experiences, and photos into personalized stories and guided conversations that help children understand, express, and practise.
        </p>

        <div className="mt-10 flex flex-wrap gap-3 text-sm font-bold text-[#40554A]">
          <span className="rounded-full border border-[#C5D2BE] bg-white/65 px-4 py-2">Personalized stories</span>
          <span className="rounded-full border border-[#C5D2BE] bg-white/65 px-4 py-2">Guided conversations</span>
          <span className="rounded-full border border-[#C5D2BE] bg-white/65 px-4 py-2">Real-life practice</span>
        </div>
      </div>
    </section>
  );
}
